import cemsPreAlarm from "./cemsPreAlarm.vue"
export default cemsPreAlarm